import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GlobeAltIcon, PlusSmIcon } from '@heroicons/react/outline';

import { useAuth } from '../../../contexts/AuthContext';

import { isProviderUserOwnerOrAdminAuthorized } from '../../../lib/auth';

import Button from '../../components/Button';
import ServicesModule from '../../components/ServiceModule';
import CreateGroupModal from '../../components/ServiceModule/CreateGroupModal';
import PageContainer from '../../components/Containers/PageContainer';
import { useServiceGroupsQuery } from '../../../generated/graphql';
import classNames from 'classnames';

const Services = () => {
  const navigate = useNavigate();
  const { authedProviderUser, showUpgradeBanner } = useAuth();
  const [isCreateGroupModalOpen, setIsCreateGroupModalOpen] = useState(false);
  const { refetch: refetchServiceGroups } = useServiceGroupsQuery();

  useEffect(() => {
    if (!isProviderUserOwnerOrAdminAuthorized(authedProviderUser)) {
      navigate('/', { replace: true });
    }
  }, [authedProviderUser]);

  return (
    <div
      className={classNames(
        'overflow-y-auto',
        showUpgradeBanner
          ? 'h-[calc(100vh-var(--top-nav-height)-var(--upgrade-banner-height))]'
          : 'h-[calc(100vh-var(--top-nav-height))]',
      )}
    >
      <div className="w-full px-20">
        <div className="sticky top-0 z-10 flex flex-row items-center justify-between gap-x-10 bg-white pt-[40px] pb-[72px] text-neutral-150">
          <div className="mr-4 flex flex-col gap-y-3">
            <h1 className="w-full font-serif text-subtitle text-neutral-150">
              Services
            </h1>
            <div className="max-w-xl text-caption">
              Create services & service groups to organize your offerings. Drag
              and drop services and groups to reorder them. View your services
              on your page when you&apos;re ready.
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Button
              title="Go to your page"
              iconPosition="left"
              IconComponent={GlobeAltIcon}
              onClick={() => navigate('/your-page')}
              theme="secondary"
              size="small"
            />
            <Button
              title="Add service group"
              iconPosition="left"
              IconComponent={PlusSmIcon}
              onClick={() => setIsCreateGroupModalOpen(true)}
              size="small"
            />
          </div>
        </div>
        <PageContainer noPadding>
          <ServicesModule className="px-0 pt-0" />
          <CreateGroupModal
            isOpen={isCreateGroupModalOpen}
            onClose={() => setIsCreateGroupModalOpen(false)}
            onSuccess={async () => {
              await refetchServiceGroups();
            }}
          />
        </PageContainer>
      </div>
    </div>
  );
};

export default Services;
